// React.
import { useContext, useEffect, useState } from 'react';

// Types.
import InstanceTarget from '../../../types/instance/InstanceTarget';
import { Deadlock } from '../../../types/instance/Deadlock';

// Components.
import DeadlocksTable from '../../../component/instance/table/DeadlocksTable';

// Helper.
import { archiverUrl, fetchResults, fetchWithAuthorization } from '../../../helpers/utils';
import FilterOption from "../../../types/instance/FilterOption";
import { showError } from '../../../utils/showAlert';

import { TimeRangeContext } from "../../../context/TimeRangeContext";
import { useNavigate } from "react-router-dom";

export default function Deadlocks(props: { instance: InstanceTarget, filterOptions: FilterOption[], setFilterOptions: Function }) {
    const {instance} = props;
    const timeRangeContext = useContext(TimeRangeContext)
    const [deadlocks, setDeadlocks] = useState<Deadlock[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!(instance.hasdeadlocks && instance.collectdeadlocks)) {
            navigate(`/not-found`)
        }
    }, [instance.id]);

    useEffect(() => {
        async function load() {
            try {
                const instanceType = instance.type || ''
                setLoading(true);
                const results: any[][] = await fetchResults(
                    [
                        fetchWithAuthorization(archiverUrl() + `/deadlock/${instanceType}?${timeRangeContext.getTimeRangeQueryString()}&id=${instance.id}`)
                    ]);

                if (active) {
                    setDeadlocks(results[0]);
                    setLoading(false);
                }
            } catch (x: any) {
                console.log(x.message);
                const errorMessage = x.message || x.toString();
                setError(errorMessage);
                showError('Failed to load deadlocks', errorMessage);
                setDeadlocks([]);
                setLoading(false);
            }
        }

        let active: boolean = true;
        load();
        return () => {
            // Clean up afterwards to avoid race conditions.
            active = false;
        }
    }, [timeRangeContext, instance.id]);

    return (<>
        <div className="row row-cols-1">
            <div id="statements" className="tab-pane fade show active" role="tabpanel" aria-labelledby="statements-tab">
                <DeadlocksTable setFilterOptions={props.setFilterOptions} instanceType={instance.type} filterOptions={props.filterOptions}
                                loading={loading} error={error} deadlocks={deadlocks}/>
            </div>
        </div>
    </>)
}
